import React from 'react';

import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface IStep {
  step: string;
  name: string;
  description: string;
  share?: string;
}

interface IRoundDiagramStepProps {
  stepInfo: IStep;
  stepsQuantity: number;
  isLastOne: boolean;
  colors: string[];
  smallFontSize?: boolean;
}

const getColor = (step: string, colors: string[]) => {
  switch (step) {
    case '01':
      return colors[0];
    case '02':
      return colors[1];
    case '03':
      return colors[2];
    case '04':
      return colors[3];
    case '05':
      return colors[4];
    default:
      return colors[0];
  }
};

const getStyles = (quantity: number, step: string, isLastOne: boolean) => {
  let marginBottom = '9px';
  let marginLeft = '0px';

  switch (quantity) {
    case 3:
      if (step === '01' || step === '03') {
        marginLeft = '-34px';
      }
      break;
    case 4:
      if (step === '01' || step === '04') {
        marginLeft = '-34px';
      }
      break;
    case 5:
      if (step === '01' || step === '05') {
        marginLeft = '-93px';
      } else if (step === '02' || step === '04') {
        marginLeft = '-17px';
      }
      break;
    default:
      break;
  }

  if (isLastOne) {
    marginBottom = '0px';
  }

  return { marginBottom, marginLeft };
};

export const RoundDiagramStep: React.FC<IRoundDiagramStepProps> = ({
  stepInfo,
  stepsQuantity,
  isLastOne = false,
  colors,
  smallFontSize = false,
}) => {
  const color = getColor(stepInfo.step, colors.slice(1));
  const { marginBottom, marginLeft } = getStyles(stepsQuantity, stepInfo.step, isLastOne);
  const fontSize = smallFontSize ? styles.smallFontSize : styles.defaultFontSize;
  return (
    <View style={[styles.wrap, { backgroundColor: colors[0] }, { marginBottom, marginLeft }]}>
      <View style={[styles.numberWrap, { backgroundColor: color }]}>
        <Text style={styles.number}>{stepInfo.share ? `${stepInfo.share}%` : stepInfo.step}</Text>
      </View>
      <View style={styles.infoWrap}>
        <View style={styles.textWrap}>
          <Text style={[styles.heading, { color }, fontSize]}>{stepInfo.name}</Text>
          <Text style={[styles.text, fontSize]}>{stepInfo.description}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    width: '100%',
    minHeight: '44px',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#212121',
  },
  numberWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '34px',
    height: '100%',
  },
  number: {
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: '13px',
    color: '#FFFFFF',
  },
  infoWrap: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  textWrap: {
    padding: '4px 12px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  defaultFontSize: {
    fontSize: 9,
  },
  smallFontSize: {
    fontSize: 8,
  },
  heading: {
    fontFamily: 'Noto',
    fontWeight: 600,
    width: '310px',
  },
  text: {
    fontFamily: 'Noto',
    fontWeight: 300,
    width: '310px',
  },
});
